export default __webpack_public_path__ + "static/studio-to-sea-banner-mobile-5e98437e25a4b91f7e9ce98af78f1614.webp";